module.exports = __webpack_public_path__ + "static/img/lunboImg bg002.f2a7d512.jpg";